import React from 'react';

const Footer = () => (
    <div className = { 'footer-stack' }>
        <p
            className = { 'font-size-350 footer-content footer-content-600' }>
                © 2023 Comrex Corporation. All Rights Reserved
        </p>
    </div>
);

export default Footer;
